export default __webpack_public_path__ + "static/media/pfp2.fd9b1716.jpg";